import { Component } from '@angular/core';

@Component({
    selector: 'app-self-care-chip',
    templateUrl: './self-care-chip.component.html',
    styleUrl: './self-care-chip.component.scss',
})
export class SelfCareChipComponent {}
